import axiosClient from './../../plugins/axios'
import router from "../../shared/router";
import authService from "./auth.service";

export const HTTP_UNAUTHORIZED = 401;
export const HTTP_NOT_ALLOWED = 405;
export const HTTP_FORBIDDEN = 403;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_NOT_FOUND = 404;
export const HTTP_INTERNAL_SERVER_ERROR = 500;

function getEmptyResolveObject() {
  return {
    success: true,
    body: null,
    errors: [],
    toastError: null,
  };
}

function handleExceptionResponse(response, resolveObj, ignore_forbidden) {
  if (!response) {
    resolveObj.success = false;
    resolveObj.body = {};
    resolveObj.response = {};
    return resolveObj
  }

  resolveObj.success = false;
  resolveObj.body = response.data;
  resolveObj.response = response;

  if (response.status === HTTP_UNAUTHORIZED) {
    authService.logout();
  } else if (response.status === HTTP_NOT_ALLOWED) {
    resolveObj.toastError = 'Requested method is not allowed.';
  } else if (response.status === HTTP_BAD_REQUEST) {
    //todo improve error parsing

    for (let key in response.body) {
      let innerData = response.body[key];
      // This means that inner data is an array
      if (innerData.length !== undefined) {
        innerData.forEach((error) => {
          resolveObj.errors.push(error);
        })
      }
    }
  } else if (response.status === HTTP_NOT_FOUND) {
    resolveObj.toastError = 'Requested data was not found.';
  } else if (response.status === HTTP_INTERNAL_SERVER_ERROR) {
    resolveObj.toastError = "An error has occurred while processing your request and we're working to fix the problem! If you keep encountering same issue please contact us at helpdesk@artisio.co";
  } else if (response.status === HTTP_FORBIDDEN) {
    if (!ignore_forbidden) {
      router.push({name: 'forbidden'});
    } else {
      resolveObj.toastError = 'You do not have permission to perform following action.';
    }
  } else {
    resolveObj.toastError = 'Something went wrong.';
  }

  return resolveObj;
}

function handleSuccessResponse(response, resolveObj) {
  resolveObj.success = true;
  resolveObj.body = response.data;
  resolveObj.response = response;
  return resolveObj;
}

function runRequest(requestType, url, data, options, ignore_forbidden = false) {
  return new Promise(async (resolve) => {
    let resolveObj = getEmptyResolveObject();
    try {
      let response = await axiosClient[requestType](url, data, options);
      resolve(handleSuccessResponse(response, resolveObj));
    } catch (data) {
      resolve(handleExceptionResponse(data.response, resolveObj, ignore_forbidden));
    }
  });
}

const http = {
  get: (url, data, options) => runRequest('get', url, data, options),
  put: (url, data, options) => runRequest('put', url, data, options),
  patch: (url, data, options) => runRequest('patch', url, data, options),
  post: (url, data, options, ignore_forbidden = false) => runRequest('post', url, data, options, ignore_forbidden),
  delete: (url, data, options) => runRequest('delete', url, data, options)
};

export default http;
